<template>
	<v-dialog
		v-model="dialog"
		:max-width="lgAndUp ? maxWidth : '100%'"
		v-bind="$attrs"
		:persistent="persistent"
		:fullscreen="!lgAndUp">
		<div
			class="relative bg-white rounded d-flex flex-column"
			:class="[`${lgAndUp ? 'h-auto' : 'h-screen'}`]">
			<div class="absolute" :style="closeBtnStyle" v-if="closeBtn">
				<v-btn density="comfortable" icon color="red lighten-2" @click="close">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</div>

			<div class="text-center flex-shrink-0 pt-5" v-if="logo">
				<v-img
					:src="assetsUrl('img/logo.png')"
					class="mx-auto mb-4 d-lg-none"
					:width="80"
					:height="80" />
				<div class="d-none d-lg-block">
					<v-img
						:src="assetsUrl('img/logo.png')"
						class="mx-auto mb-4"
						style="margin-top: -60px"
						:width="80"
						:height="80" />
				</div>
			</div>

			<div class="scroll-content" :class="className">
				<slot />

				<div v-if="!isBigCloseBtnHidden" class="text-center mt-4">
					<v-btn
						class="text-white"
						color="primary"
						elevation="0"
						@click="close()"
						style="min-width: 120px">
						Ok
					</v-btn>
				</div>
			</div>
		</div>
	</v-dialog>
</template>
<script>
import { useDisplay } from 'vuetify';
export default {
	props: {
		modelValue: {},
		className: {
			type: String,
			default: 'pa-5',
		},
		maxWidth: {
			type: Number,
			default: 500,
		},
		persistent: {
			type: Boolean,
			default: false,
		},
		closeBtn: {
			type: Boolean,
			default: true,
		},
		confirmBtn: {
			type: Boolean,
			default: false,
		},
		logo: {
			type: Boolean,
			default: true,
		},
		isBigCloseBtnHidden: {
			type: Boolean,
			default: false,
		},
	},
	setup() {
		const { lgAndUp } = useDisplay();
		return { lgAndUp };
	},
	computed: {
		dialog: {
			get() {
				return this.modelValue;
			},
			set(val) {
				this.$emit('update:modelValue', val);
			},
		},
		closeBtnStyle() {
			return this.lgAndUp
				? { right: '-0.5rem', top: '-0.5rem', zIndex: 2 }
				: { right: '0.5rem', top: '0.5rem', zIndex: 2 };
		},
	},
	methods: {
		open() {
			this.dialog = true;
		},
		close() {
			this.dialog = false;
			this.$emit('onClose');
		},
	},
};
</script>
<style lang="scss" scoped>
.theme--light {
	.v-dialog {
		.v-card {
			background-color: #f8f8f8 !important;
		}
	}
}
.right-0 {
	right: 0;
}
.h-auto {
	max-height: 90vh;
}
.scroll-content {
	flex: 1 1 auto;
	min-height: 0;
	overflow-y: auto;
	overflow-x: hidden;
}
</style>
